import { render, staticRenderFns } from "./clear-note-modal.vue?vue&type=template&id=369053b0"
import script from "./clear-note-modal.vue?vue&type=script&lang=js"
export * from "./clear-note-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports